import { createAction } from "@reduxjs/toolkit";
import { SessaoState } from "./sessaoTypes";

export const loginAction = createAction<SessaoState>("SESSAO/SET");
export const logoutAction = createAction<void>("SESSAO/REMOVE");
export const removeTokenAction = createAction("SESSAO/REMOVE_TOKEN");
